<template>
  <div class="col-sm-12">
    <h6>Loturi adjudecate:</h6>
    <hr>
    <!-- Won lots start-->
    <div v-for="(lot, index) in won" :key="index" class="row">
      <div class="col-md-3">
        <input type="checkbox" id="checkbox" checked disabled>
        {{index + 1}}. <span class="pl-1">{{lot.lot.title}}</span>
      </div>
      <div class="col-md-3"> <small class="text-muted">{{lot.lot.translations[0].old_artist}}</small> </div>
      <div class="col-md-5"> <small class="text-muted">{{lot.lot.auction.name}}</small> </div>
      <div class="col-md-1">  <small class="text-muted"><b>{{lot.suma}} ron</b></small></div>
    </div>
    <hr>
    <!-- Won lots end -->

    <!-- Payment form start -->
    <div class="row d-flex justify-content-between mt-5" v-if="showForm">
      <div class="col-sm-12 col-md-3 mb-2"><h5 class="mb-0">COMANDA TA</h5></div>
      <div class="col-sm-12 col-md-3 text-right"><h6 class="text-muted">pasul 1/ 2</h6></div>
      <div class="col-sm-12">
        <p class="text-muted h7">
          <span>
            <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
              	 viewBox="0 0 92 92" style="enable-background:new 0 0 92 92;" xml:space="preserve" width="20px" height="20px">
              <g>
              	<path style="fill:#bbb;" d="M45.386,0.004C19.983,0.344-0.333,21.215,0.005,46.619c0.34,25.393,21.209,45.715,46.611,45.377
              		c25.398-0.342,45.718-21.213,45.38-46.615C91.656,19.986,70.786-0.335,45.386,0.004z M45.25,74l-0.254-0.004
              		c-3.912-0.116-6.67-2.998-6.559-6.852c0.109-3.788,2.934-6.538,6.717-6.538l0.227,0.004c4.021,0.119,6.748,2.972,6.635,6.937
              		C51.904,71.346,49.123,74,45.25,74z M61.705,41.341c-0.92,1.307-2.943,2.93-5.492,4.916l-2.807,1.938
              		c-1.541,1.198-2.471,2.325-2.82,3.434c-0.275,0.873-0.41,1.104-0.434,2.88l-0.004,0.451H39.43l0.031-0.907
              		c0.131-3.728,0.223-5.921,1.768-7.733c2.424-2.846,7.771-6.289,7.998-6.435c0.766-0.577,1.412-1.234,1.893-1.936
              		c1.125-1.551,1.623-2.772,1.623-3.972c0-1.665-0.494-3.205-1.471-4.576c-0.939-1.323-2.723-1.993-5.303-1.993
              		c-2.559,0-4.311,0.812-5.359,2.478c-1.078,1.713-1.623,3.512-1.623,5.35v0.457H27.936l0.02-0.477
              		c0.285-6.769,2.701-11.643,7.178-14.487C37.947,18.918,41.447,18,45.531,18c5.346,0,9.859,1.299,13.412,3.861
              		c3.6,2.596,5.426,6.484,5.426,11.556C64.369,36.254,63.473,38.919,61.705,41.341z"/>
              </g>
              </svg>
          </span>
          Completeaza datele personale si apasa pe butonul <strong>Plateste</strong> de mai jos pentru a finaliza comanda</p>
      </div>

      <div class="col-sm-12">
        <form class="input-group mt-5 col-lg-8 col-md-9 pl-0" method="POST" action="javascript:void();">
          <h6><strong>Date personale:</strong></h6>

          <!-- Personal details: First Name -->
          <div class="input-group my-2">
            <div class="input-group-prepend">
              <span class="input-group-text rounded-0 bg-transparent input-group-prepend-account border-0 h6">First name:</span>
            </div>
            <input type="text" class="form-control rounded-0 bg-light myAccount-form-control-custom" style="border: 1px solid #dee2e6 !important" name="first name" v-model="order.personal.first_name" v-validate="'required|alpha'"/>
          </div>
          <div class="input-group-prepend">
            <span class="input-group-text rounded-0 bg-transparent input-group-prepend-account border-0 h6"></span>
          </div>
          <span class="text-danger h8">{{ errors.first('first name') }}</span>

          <!-- Personal details: Last Name -->
          <div class="input-group my-2">
            <div class="input-group-prepend">
              <span class="input-group-text rounded-0 bg-transparent input-group-prepend-account border-0 h6">Last name:</span>
            </div>
            <input type="text" class="form-control rounded-0 bg-light myAccount-form-control-custom" style="border: 1px solid #dee2e6 !important" name="last name" v-model="order.personal.last_name" v-validate="'required|alpha'" required/>
          </div>
          <div class="input-group-prepend">
            <span class="input-group-text rounded-0 bg-transparent input-group-prepend-account border-0 h6"></span>
          </div>
          <span class="text-danger h8">{{ errors.first('last name') }}</span>

          <!-- Personal details: Phone number -->
          <div class="input-group my-2">
            <div class="input-group-prepend">
              <span class="input-group-text rounded-0 bg-transparent input-group-prepend-account border-0 h6">Phone:</span>
            </div>
            <input type="text" class="form-control rounded-0 bg-light myAccount-form-control-custom" style="border: 1px solid #dee2e6 !important; background-color:transparent;" name="phone number" v-model="order.personal.phone_number" v-validate="'required|numeric'" />
          </div>
          <div class="input-group-prepend">
            <span class="input-group-text rounded-0 bg-transparent input-group-prepend-account border-0 h6"></span>
          </div>
          <span class="text-danger h8">{{ errors.first('phone number') }}</span>

          <!-- Personal details: Email address -->
          <div class="input-group my-2">
            <div class="input-group-prepend">
              <span class="input-group-text rounded-0 bg-transparent input-group-prepend-account border-0 h6">Email:</span>
            </div>
            <input type="text" class="form-control rounded-0 bg-light myAccount-form-control-custom text-muted" style="border: 1px solid #dee2e6 !important; background-color:#bbb; !important;" v-model="order.personal.email" v-validate.initial="'required|email'" name="email" />
          </div>
          <div class="input-group-prepend">
            <span class="input-group-text rounded-0 bg-transparent input-group-prepend-account border-0 h6"></span>
          </div>
          <span class="text-danger h8">{{ errors.first('email') }}</span>
          <br />

          <!-- Company details checkbox - default set to false. If true, open form -->
          <div class="input-group my-2">
            <div class="input-group-prepend"></div>
            <div class="form-check form-check-inline">
              <input type="checkbox" name="companyReceipt" id="companyReceipt" value="1" class="form-check-input" @click=showCompanyField()>
              <label for="companyReceipt" class="form-check-label text-muted h7">Doresc factura pe firma</label>
            </div>
          </div>

          <!-- Company details: Company Name -->
          <div class="input-group my-2" v-if="companyReceipt">
            <div class="input-group-prepend">
              <span class="input-group-text rounded-0 bg-transparent input-group-prepend-account border-0 h6">Nume:</span>
            </div>
            <input type="text" class="form-control rounded-0 bg-light myAccount-form-control-custom text-muted" style="border: 1px solid #dee2e6 !important; background-color:#bbb; !important;" name="name" v-validate.initial="'required'" v-model="order.company.company_name"   required/>
          </div>
          <div class="input-group-prepend">
            <span class="input-group-text rounded-0 bg-transparent input-group-prepend-account border-0 h6"></span>
          </div>
          <span class="text-danger h8">{{ errors.first('name') }}</span>

          <!-- Company details: CUI -->
          <div class="input-group my-2" v-if="companyReceipt">
            <div class="input-group-prepend">
              <span class="input-group-text rounded-0 bg-transparent input-group-prepend-account border-0 h6">CUI:</span>
            </div>
            <input type="text" class="form-control rounded-0 bg-light myAccount-form-control-custom text-muted" style="border: 1px solid #dee2e6 !important; background-color:#bbb; !important;" name="registration number" v-validate.initial="'required'" v-model="order.company.cui"/>
          </div>
          <div class="input-group-prepend">
            <span class="input-group-text rounded-0 bg-transparent input-group-prepend-account border-0 h6"></span>
          </div>
          <span class="text-danger h8">{{ errors.first('registration number') }}</span>

          <!-- Company details: RO -->
          <div class="input-group my-2" v-if="companyReceipt">
            <div class="input-group-prepend">
              <span class="input-group-text rounded-0 bg-transparent input-group-prepend-account border-0 h6">RO:</span>
            </div>
            <input type="text" class="form-control rounded-0 bg-light myAccount-form-control-custom text-muted" style="border: 1px solid #dee2e6 !important; background-color:#bbb; !important;" name="company name" v-validate.initial="'required'" v-model="order.company.ro" />
          </div>
          <div class="input-group-prepend">
            <span class="input-group-text rounded-0 bg-transparent input-group-prepend-account border-0 h6"></span>
          </div>
          <span class="text-danger h8">{{ errors.first('company name') }}</span>

          <!-- Company details: Street Address -->
          <div class="input-group my-2" v-if="companyReceipt">
            <div class="input-group-prepend">
              <span class="input-group-text rounded-0 bg-transparent input-group-prepend-account border-0 h6">Strada:</span>
            </div>
            <input type="text" class="form-control rounded-0 bg-light myAccount-form-control-custom text-muted" style="border: 1px solid #dee2e6 !important; background-color:#bbb; !important;" v-validate.initial="'required'" name="street address" v-model="order.company.street_address" />
          </div>
          <div class="input-group-prepend">
            <span class="input-group-text rounded-0 bg-transparent input-group-prepend-account border-0 h6"></span>
          </div>
          <span class="text-danger h8">{{ errors.first('street address') }}</span>

          <!-- Company details: Judet -->
          <div class="input-group my-2" v-if="companyReceipt">
            <div class="input-group-prepend">
              <span class="input-group-text rounded-0 bg-transparent input-group-prepend-account border-0 h6">Judet:</span>
            </div>
            <input type="text" class="form-control rounded-0 bg-light myAccount-form-control-custom text-muted" style="border: 1px solid #dee2e6 !important; background-color:#bbb; !important;" name="county" v-validate.initial="'required'" v-model="order.company.county" />
          </div>
          <div class="input-group-prepend">
            <span class="input-group-text rounded-0 bg-transparent input-group-prepend-account border-0 h6"></span>
          </div>
          <span class="text-danger h8">{{ errors.first('county') }}</span>

          <!-- Company details: Cod postal -->
          <div class="input-group my-2" v-if="companyReceipt">
            <div class="input-group-prepend">
              <span class="input-group-text rounded-0 bg-transparent input-group-prepend-account border-0 h6">Cod postal:</span>
            </div>
            <input type="text" class="form-control rounded-0 bg-light myAccount-form-control-custom text-muted" style="border: 1px solid #dee2e6 !important; background-color:#bbb; !important;" v-validate.initial="'required'" name="postal code" v-model="order.company.postal_code"/>
          </div>
          <div class="input-group-prepend">
            <span class="input-group-text rounded-0 bg-transparent input-group-prepend-account border-0 h6"></span>
          </div>
          <span class="text-danger h8">{{ errors.first('postal code') }}</span>

          <!-- Company details: Tara -->
          <div class="input-group my-2" v-if="companyReceipt">
            <div class="input-group-prepend">
              <span class="input-group-text rounded-0 bg-transparent input-group-prepend-account border-0 h6">Tara:</span>
            </div>
            <input type="text" class="form-control rounded-0 bg-light myAccount-form-control-custom text-muted" style="border: 1px solid #dee2e6 !important; background-color:#bbb; !important;" v-validate.initial="'required'" name="country" v-model="order.company.country"/>
          </div>
          <div class="input-group-prepend" v-if="errors.first('country')">
            <span class="input-group-text rounded-0 bg-transparent input-group-prepend-account border-0 h6"></span>
          </div>
            <span class="text-danger h8" v-if="errors.first('country')">{{ errors.first('country') }}</span>

          <div class="col-12 ml-0 pl-0">
          <h6 class="mt-4"><strong>Date livrare:</strong></h6>
          </div>

          <!-- Livrare: Strada-->
          <div class="input-group my-2">
            <div class="input-group-prepend">
              <span class="input-group-text rounded-0 bg-transparent input-group-prepend-account border-0 h6">Strada:</span>
            </div>
            <input type="text" class="form-control rounded-0 bg-light myAccount-form-control-custom" style="border: 1px solid #dee2e6 !important" v-validate="'required'" name="street address" v-model="order.shipping_address.street_address"  />
          </div>
          <div class="input-group-prepend">
            <span class="input-group-text rounded-0 bg-transparent input-group-prepend-account border-0 h6"></span>
          </div>
          <span class="text-danger h8">{{ errors.first('street address') }}</span>

          <!-- Livrare: Oras-->
          <div class="input-group my-2">
            <div class="input-group-prepend">
              <span class="input-group-text rounded-0 bg-transparent input-group-prepend-account border-0 h6">Oras:</span>
            </div>
            <input type="text" class="form-control rounded-0 bg-light myAccount-form-control-custom" style="border: 1px solid #dee2e6 !important; background-color:transparent;" v-validate="'required'" name="city" v-model="order.shipping_address.city" required/>
          </div>
          <div class="input-group-prepend">
            <span class="input-group-text rounded-0 bg-transparent input-group-prepend-account border-0 h6"></span>
          </div>
          <span class="text-danger h8">{{ errors.first('city') }}</span>

          <!-- Livrare: Cod postal-->
          <div class="input-group my-2">
            <div class="input-group-prepend">
              <span class="input-group-text rounded-0 bg-transparent input-group-prepend-account border-0 h6">Cod postal:</span>
            </div>
            <input type="text" class="form-control rounded-0 bg-light myAccount-form-control-custom" style="border: 1px solid #dee2e6 !important; background-color:transparent;" name="postal code" v-validate="'required'" v-model="order.shipping_address.postal_code" required/>
          </div>
          <div class="input-group-prepend">
            <span class="input-group-text rounded-0 bg-transparent input-group-prepend-account border-0 h6"></span>
          </div>
          <span class="text-danger h8">{{ errors.first('postal code') }}</span>

          <!-- Livrare: Judet-->
          <div class="input-group my-2">
            <div class="input-group-prepend">
              <span class="input-group-text rounded-0 bg-transparent input-group-prepend-account border-0 h6">Judet:</span>
            </div>
            <input type="text" class="form-control rounded-0 bg-light myAccount-form-control-custom" style="border: 1px solid #dee2e6 !important; background-color:transparent;" name="region" v-validate="'required'" v-model="order.shipping_address.region" required/>
          </div>
          <div class="input-group-prepend">
            <span class="input-group-text rounded-0 bg-transparent input-group-prepend-account border-0 h6"></span>
          </div>
          <span class="text-danger h8">{{ errors.first('region') }}</span>

          <!-- Livrare: Tara-->
          <div class="input-group my-2">
            <div class="input-group-prepend">
              <span class="input-group-text rounded-0 bg-transparent input-group-prepend-account border-0 h6">Tara:</span>
            </div>
            <input type="text" class="form-control rounded-0 bg-light myAccount-form-control-custom" style="border: 1px solid #dee2e6 !important; background-color:transparent;" v-validate="'required'" name="country" v-model="order.shipping_address.country" required/>
          </div>
          <div class="input-group-prepend">
            <span class="input-group-text rounded-0 bg-transparent input-group-prepend-account border-0 h6"></span>
          </div>
          <span class="text-danger h8">{{ errors.first('country') }}</span>

          <!-- Metoda de livrare-->
        <div class="col-12 ml-0 pl-0">
            <h6 class="mt-5"><strong>Alege metoda de livrare:</strong></h6>
        </div>

          <!-- Metoda de livrare: Serviciul de livrare A10-->
          <div class="input-group">
            <div class="input-group-prepend"></div>
            <div class="form-check form-check-inline">
              <input type="radio" name="a10Delivery" id="a10Delivery" value="a10_delivery" class="form-check-input" v-model='order.delivery_method'>
              <label for="a10Delivery" class="input-group-text rounded-0 bg-transparent input-group-prepend-account border-0 h6 pl-1">Serviciul de livrare A10</label>
            </div>
            <p class="text-muted h8 font-italic mb-0 mt-0">* Veti fi contactat de catre un reprezentant Artmark pentru stabilirea tuturor detaliilor necesare livrarii. Costurile livrarii vor fi comunicate ulterior si reflectate printr-o tranzactie noua.</p>
          </div>

        <!-- Metoda de livrare: Ridicare personala -->
        <div class="input-group">
          <div class="input-group-prepend"></div>
          <div class="form-check form-check-inline">
            <input type="radio" name="personalPickUp" id="inlineRadio1" value="personalPickUp" class="form-check-input" v-model='order.delivery_method'>
            <label for="personalPickUp" class="input-group-text rounded-0 bg-transparent input-group-prepend-account border-0 h6 pl-1">Ridicare personala</label>
          </div>
        </div>

        <!-- Metoda de plata-->
          <h6 class="mt-5"><strong>Alege metoda de plata:</strong></h6>
          <div class="input-group">
            <div class="input-group-prepend"></div>
            <div class="form-check form-check-inline">
              <input type="radio" name="paymentMethod" id="paymentMethod" value="1" class="form-check-input" checked>
              <label for="paymentMethod" class="form-check-label text-muted">Plata online cu cardul</label>
            </div>
              <p class="text-muted h8 mt-2 font-italic">* Plata se face online prin MobilPay.ro. Dupa finalizarea comenzii veti fi redirectionat la site-ul securizat MobilPay.ro unde veti introduce datele cardului.</p>
          </div>

          <!-- Comentarii-->
          <h6 class="mt-2"><strong>Comentarii</strong></h6>
          <div class="input-group">
            <div class="input-group-prepend"></div>
            <textarea class="form-control w-100" id="comments" rows="3" style="background-color: transparent !important;" v-model="order.comments"></textarea>
              <p class="text-muted h8 mt-2 font-italic">* Trimite un mesaj echipei A10.</p>
          </div>

          <!-- Checkbox politici confidentialitate-->
          <div class="input-group my-2">
            <div class="input-group-prepend"></div>
             <div class="form-check form-check-inline col-12">
              <input type="checkbox" name="confidentialityPolicy" id="confidentialityPolicy" class="form-check-input" v-model="order.privacy_policy.confidentiality">
              <label for="confidentialityPolicy" class="form-check-label text-muted h7">Sunt de acord cu <a href="#" class="nounderline" required >politica de confidentialitate</a></label>
            </div>
            <div class="input-group-prepend"></div>
             <div class="form-check form-check-inline col-12">
              <input type="checkbox" name="shippingPolicy" id="shippingPolicy" class="form-check-input" v-model="order.privacy_policy.shipping">
              <label for="shippingPolicy" class="form-check-label text-muted h7">Sunt de acord cu <a href="#" class="nounderline" required >politica de tranport</a></label>
            </div>
            <div class="input-group-prepend"></div>
             <div class="form-check form-check-inline col-12">
              <input type="checkbox" name="a10Policy" id="a10Policy" class="form-check-input" v-model="order.privacy_policy.a10">
              <label for="a10Policy" class="form-check-label text-muted h7">Sunt de acord cu <a href="#" class="nounderline" required>politica A10</a></label>
            </div>
          </div>
          <h6 class="mt-4"><strong>TOTAL DE PLATA: {{X}} RON</strong></h6>

          <!-- errors -->
          <div class="alert alert-danger alert-dismissible fade show col-12" role="alert" v-if="customErrors.length">
            <ul>
              <li  v-for="error in customErrors" class="h7"> {{error}}</li>
            </ul>
          </div>

          <div class="col-sm-12 pl-0 ml-0">
              <a href="javascript:void(0)" class="action_box_search_results mt-3" @click="formValidation()" v-if="checkout" >Pasul 2. Plateste <img src="https://a10.test/assets/img/cms/right-arrow-angle.svg" alt="Licitază" class="action_box_decoration"></a>
          </div>
        </form>
      </div>
    </div>
    <!-- Payment form end -->
    <a href="javascript:void(0)" class="action_box_search_results mt-3" @click="launchForm" v-if="!checkout" >Plateste <img src="https://a10.test/assets/img/cms/right-arrow-angle.svg" alt="Licitază" class="action_box_decoration"></a>
  </div>
</template>

<script>
export default {
  name: "won-lots",
  props : ['won', 'url' , 'user', 'addresses'],
  data: function() {
    return {
      showForm: false, //change to false to hide form on load
      companyReceipt: false,
      totalAmount: 0,
      checkout: false,
      customErrors: [],
      order: {
        items: this.won,
        personal: {
          first_name : this.user.first_name,
          last_name : this.user.last_name,
          phone_number : this.user.phone_number,
          email : this.user.email,
        },
        company: {
          company_name : '',
          cui: '',
          ro: '',
          street_address: '',
          county: '',
          postal_code: '',
          country: ''
        },
        shipping_address: {
          street_address: this.addresses.address,
          city: this.addresses.city,
          region: this.addresses.region,
          postal_code: this.addresses.postal_code,
          country: this.addresses.country_id,
        },
        payment_method: 'credit_card',
        delivery_method: '',
        comments: '',
        privacy_policy: {
          confidentiality: false,
          shipping: false,
          a10: false,
        },
      },
    }
  },
  methods: {
    showCompanyField: function() {
      if (this.companyReceipt == false) {
        this.companyReceipt = true
      } else {
        this.companyReceipt = false
      }
    },
    launchForm: function() {
      this.showForm = true;
      this.checkout = true;
    },
    formValidation: function() {
      this.customErrors = [];
      if (this.order.delivery_method === '') {
        this.customErrors.push('You must select a delivery method');
      }
      if (this.order.privacy_policy.confidentiality === false) {
        this.customErrors.push("You must agree with A10's Confidentiality Policy");
      }
      if (this.order.privacy_policy.shipping === false) {
        this.customErrors.push("You must agree with A10's Shipping Policy");
      }
      if (this.order.privacy_policy.a10 === false) {
        this.customErrors.push("You must agree with A10's Auction House Policy");
      }

      if (!this.errors.items.length && !this.customErrors.length) {
        this.sendOrder();
      }
    },
    sendOrder: function() {
      var that = this;
      axios.post('/account/my-offers/place-order', {
        params: {
                user_id: that.user.id,
                order: this.order,
                amount: that.X,
              }
            }).then(function (response) {
             console.log('successfuly placed order. Redirecting now to MobilPay ...');
             let formData = new FormData();
             axios.post('http://sandbox.mobilpay.ro/card3').then().catch();
      }).catch(function (error) {
          if (typeof error !== 'undefined'){
            if (error.response.status == 422) {
              let errors = Object.values(error.response.data.errors);
                errors = errors.flat();
                that.customErrors = errors;
              }
            }
      });
    },
  },
  computed: {
    X: function() {
      var sum = 0;
      this.won.forEach(function(winner) {
        sum += winner.suma
      });
      return sum;
    },
  },
}
</script>
